import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
export var EXTERNAL_RESOURCE_NAME = 'EXTERNAL-JS-RESOURCES';
var INVALID_HOSTNAME = 'invalid hostname';
export var getJSResourcesMetrics = function getJSResourcesMetrics(telemetry) {
  var result = {
    internalResource: {
      resources: []
    },
    combinedExternalResource: {
      resourceName: '',
      totalResourceCount: 0
    }
  };
  return performance.getEntriesByType('resource').filter(function (resource) {
    return resource.initiatorType === 'script';
  }).map(function (resource) {
    // Example: resource.name is 'https://myapplications.microsoft.com/bundle/moderate-change-freq-vendors.8d4e8f51.js
    // we just want moderate-change-freq-vendors.8d4e8f51.js in the map function
    var resourceName;
    var hostname;

    try {
      var _url$pathname$split$p;

      var url = new URL(resource.name);
      hostname = url.hostname;
      resourceName = (_url$pathname$split$p = url.pathname.split('/').pop()) !== null && _url$pathname$split$p !== void 0 ? _url$pathname$split$p : resource.name;
    } catch (error) {
      resourceName = resource.name;
      hostname = INVALID_HOSTNAME;
      telemetry.error('urlConstructionError', {
        error: error,
        resourceName: resource.name
      });
    }

    var isCached = isResourceCached(resource);
    var metadata = {
      resourceName: resourceName,
      originalName: resource.name,
      hostname: window.location.hostname,
      isInternal: hostname === window.location.hostname,
      resourceLoadTime: resource.duration,
      transferSize: isCached === undefined ? undefined : isCached ? 0 : resource.transferSize
    };
    return metadata;
  }).reduce(function (result, resourceMetadata) {
    if (resourceMetadata.isInternal) {
      result.internalResource = updateInternalResourceMetric(resourceMetadata, result.internalResource);
    } else {
      result.combinedExternalResource = updateCombinedExternalResourceMetric(result.combinedExternalResource);
    }

    return result;
  }, result);
};

var isResourceCached = function isResourceCached(resource) {
  var transferSize = resource.transferSize,
      nextHopProtocol = resource.nextHopProtocol;

  if (transferSize !== undefined) {
    // transferSize is set to 0 when serving from cached with 200 Http status code
    // transferSize is set to 300 when serving from cached with 304 Http status code ( header size )
    // both cases are considered cached
    return transferSize === 0 || transferSize === 300;
  } // use this field to determine the cache status when transferSize is not available on this browser


  if (nextHopProtocol !== undefined) {
    return nextHopProtocol === '';
  }

  return undefined;
};

var updateInternalResourceMetric = function updateInternalResourceMetric(resourceMetadata, internalResource) {
  var resourceName = resourceMetadata.resourceName,
      resourceLoadTime = resourceMetadata.resourceLoadTime,
      transferSize = resourceMetadata.transferSize,
      hostname = resourceMetadata.hostname,
      isInternal = resourceMetadata.isInternal;
  internalResource.resources.push({
    resourceName: resourceName,
    resourceLoadTime: resourceLoadTime,
    transferSize: transferSize,
    hostname: hostname,
    isInternal: isInternal
  });
  return internalResource;
};

var updateCombinedExternalResourceMetric = function updateCombinedExternalResourceMetric(currentExternalResource) {
  return {
    resourceName: EXTERNAL_RESOURCE_NAME,
    totalResourceCount: currentExternalResource.totalResourceCount + 1
  };
};
//# sourceMappingURL=getResourcesMetrics.js.map